<ion-card class="notification">
  <ion-card-content class="notification__content">
    <div class="notification__row">
      <div class="df fd-row ai-c">
        <img
          src="assets/icons/information-circle.svg"
          class="icon-header"
          alt="info"
        />
        <span class="t-align-left ion-color-grey-5 mapfre-fs-xs">
          {{ text }}
        </span>
      </div>
      <div class="df ai-c fd-row">
        <ion-button
          *ngIf="data?.buttonText"
          fill="clear"
          color="dark"
          class="notification__button start t-upper mapfre-fw-500 ls-n ion-no-padding mapfre-mr-sm"
          (click)="onAction()"
        >
          {{ data.buttonText }}
        </ion-button>
        <ion-button
          *ngIf="data?.daysUntilNextView"
          fill="clear"
          color="dark"
          class="notification__button start t-upper mapfre-fw-500 ls-n ion-no-padding mapfre-mr-sm"
          (click)="onLater()"
        >
          {{ 'LATER' | translate }}
        </ion-button>
      </div>
    </div>
    <div class="df jc-e notification__close">
      <img
      class="pa"
      (click)="onClose()"
      src="assets/icons/close.svg"
      alt="close">
    </div>
  </ion-card-content>
</ion-card>
